import { type UseQueryResult, useQuery } from 'react-query';
import {
  CustomerOptionDto,
  CustomerSuccessOptionsAppserviceService,
} from '../../services/wealthlane-customer-services';

const useGetCompanies = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<Array<{ label: string; value: string }> | undefined, unknown> => {
  return useQuery(
    ['getCompanies'],
    async () => {
      return await handleRequest(
        CustomerSuccessOptionsAppserviceService.getApiCustomerApiCustomerCustomerSuccessOptionsMyCompanies()
      );
    },
    {
      select(data) {
        return data?.map((company) => {
          return {
            label: company.name ?? '',
            value: company.id ?? '',
          };
        });
      },
    }
  );
};

export default useGetCompanies;
